/* Garnets wishlist (CRO Wave 3) — localStorage based, no app required */
(function () {
  const STORAGE_KEY = 'garnets_wishlist_v1';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:changed', { detail: { list } }));
  }

  function has(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }

  function add(item) {
    const list = read();
    if (list.some(function (i) { return i.handle === item.handle; })) return list;
    list.push(item);
    write(list);
    return list;
  }

  function remove(handle) {
    const list = read().filter(function (i) { return i.handle !== handle; });
    write(list);
    return list;
  }

  function syncButton(btn) {
    const handle = btn.dataset.wishlistHandle;
    const active = has(handle);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    const label = btn.querySelector('[data-wishlist-label]');
    if (label) label.textContent = active ? 'Saved to wishlist' : 'Save to wishlist';
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton);
  }

  function updateHeaderCount() {
    const count = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.toggleAttribute('hidden', count === 0);
    });
    document.querySelectorAll('[data-wishlist-link]').forEach(function (el) {
      el.classList.toggle('has-items', count > 0);
    });
  }

  function attach(btn) {
    if (btn.dataset.wishlistBound) return;
    btn.dataset.wishlistBound = '1';
    syncButton(btn);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.dataset.wishlistHandle;
      if (has(handle)) {
        remove(handle);
      } else {
        add({
          handle: handle,
          id: btn.dataset.wishlistId,
          title: btn.dataset.wishlistTitle,
          url: btn.dataset.wishlistUrl,
          image: btn.dataset.wishlistImage,
          price: btn.dataset.wishlistPrice,
          added: Date.now()
        });
      }
      syncButton(btn);
    });
  }

  function init() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(attach);
    updateHeaderCount();
    renderWishlistPage();
  }

  function renderWishlistPage() {
    const container = document.querySelector('[data-wishlist-grid]');
    if (!container) return;
    const list = read();
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!list.length) {
      container.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    container.innerHTML = list.map(function (item) {
      return '<div class="wishlist-card">' +
        '<a href="' + item.url + '" class="wishlist-card__media">' +
          (item.image ? '<img src="' + item.image + '" alt="" loading="lazy" width="300" height="300">' : '') +
        '</a>' +
        '<div class="wishlist-card__body">' +
          '<a href="' + item.url + '" class="wishlist-card__title">' + (item.title || '') + '</a>' +
          '<div class="wishlist-card__price">' + (item.price || '') + '</div>' +
          '<div class="wishlist-card__actions">' +
            '<a href="' + item.url + '" class="button button--small">View</a>' +
            '<button type="button" class="wishlist-card__remove" data-wishlist-remove="' + item.handle + '" aria-label="Remove">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
    container.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        remove(btn.dataset.wishlistRemove);
        renderWishlistPage();
      });
    });
  }

  document.addEventListener('wishlist:changed', function () {
    updateHeaderCount();
    renderWishlistPage();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton);
  });

  // Re-attach for dynamically loaded sections (e.g., quick-add, ajax filters)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('[data-wishlist-toggle]')) attach(n);
        if (n.querySelectorAll) n.querySelectorAll('[data-wishlist-toggle]').forEach(attach);
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    init();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Public API
  window.GarnetsWishlist = { read: read, has: has, add: add, remove: remove };
})();
